import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import rootReducer from "./Reducers/rootReducer";

let middleware = [ReduxThunk];

export const store = createStore(rootReducer, applyMiddleware(...middleware));
